import TestForm from "../../../../src/events/2020/08/test-event/test-form/index.js";
import * as React from 'react';
export default {
  TestForm,
  React
};